export enum DialPadVariant {
  PHONE_DEALER = 'phoneDealer',
  CALCULATOR_DEALER = 'calculatorDealer',
}
